export async function get({ isOpenOKRs, isClosedOKRs, ...filters }) {
  const response = await $.post(`${wbConfig.baseUrl}/workboard/orgEngagementFilterData`, {
    openGoal: isOpenOKRs,
    closeGoal: isClosedOKRs,
    startDate: filters.start,
    endDate: filters.end
  });

  if (response.length) {
    const data = JSON.parse(response);

    return {
      functionalTeams: data.fun_teams_count,
      workingGroups: data.wg_teams_count,
      okrCount: data.okr_count,
      krCount: data.kr_count,
      okrGreenCount: data.okr_green_count,
      krGreenCount: data.kr_green_count,
      okrLightGreenCount: data.okr_light_green_count,
      krLightGreenCount: data.kr_light_green_count,
      okrAmberCount: data.okr_amber_count,
      krAmberCount: data.kr_amber_count,
      okrRedCount: data.okr_red_count,
      krRedCount: data.kr_red_count,
      funTeamOkr: data.fun_team_okr,
      wgTeamOkr: data.wg_team_okr,
      userCount: data.user_count
    };
  }
}

export default {
  get
};
